function AnimateNav() {
  let isScrolledToTop = null;
  let currentScrollPosition = null;
  let navElement;

  function init() {
    window.addEventListener('scroll', onScroll);
  }

  function onScroll(e) {
    navElement = document.querySelector('nav');
    if (!navElement) { return; }

    if (navElement.classList.contains('nav-is-open')) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      updateScroll();
    }
  }

  function updateScroll() {
    const newScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    if (newScrollPosition !== currentScrollPosition) {
      currentScrollPosition = newScrollPosition;

      updateStickyHeader();
    }
  }

  function updateStickyHeader() {
    const atTop = currentScrollPosition <= 10;

    if (isScrolledToTop !== atTop) {
      if (atTop) {
        navElement.classList.add('is-scrolled-to-top');
      } else {
        navElement.classList.remove('is-scrolled-to-top');
      }
    }

    isScrolledToTop = atTop;
  }

  init();
}

export default AnimateNav;
